(() => {
  if (window.juniorOctoberReady) return;
  window.juniorOctoberReady = true;
  const mobile = matchMedia('(max-width:699px)');
  let visible = history.state?.juniorVisible || 6;
  // Reveal 6 at a time, but never leave a single card for another tap: 7 or fewer remaining show together.
  const nextStep = remaining => (remaining <= 7 ? remaining : 6);
  const update = () => {
    const root = document.querySelector('[data-junior-oct]');
    if (!root) return;
    const cards = [...root.querySelectorAll('.jr-oct-card')];
    cards.forEach((card, i) => { card.hidden = mobile.matches && i >= visible; });
    const more = root.querySelector('[data-jr-oct-more]');
    const remaining = Math.max(0, cards.length - visible);
    more.hidden = !mobile.matches || !remaining;
    const step = nextStep(remaining);
    more.textContent = `Show ${step} more ${step === 1 ? 'set' : 'sets'}`;
    root.querySelector('[data-jr-oct-end]').hidden = !mobile.matches || remaining > 0 || !cards.length;
  };
  document.addEventListener('click', event => {
    if (event.target.closest('a[href="#junior-payment-options"]')) {
      const details = document.getElementById('junior-payment-options');
      if (details) { details.open = true; details.querySelector('summary').focus({preventScroll:true}); }
    }
    if (!event.target.closest('[data-jr-oct-more]')) return;
    const allCards = document.querySelectorAll('[data-junior-oct] .jr-oct-card');
    const firstNew = allCards[visible];
    visible += nextStep(Math.max(0, allCards.length - visible));
    history.replaceState({...history.state, juniorVisible:visible}, "", location.href);
    update();
    firstNew?.querySelector('.jr-oct-card__actions>a')?.focus({preventScroll:true});
  });
  document.addEventListener('junior:results-updated', () => { visible = history.state?.juniorVisible || 6; update(); });
  document.addEventListener('shopify:section:load', update);
  window.addEventListener('pageshow', () => { visible = history.state?.juniorVisible || 6; update(); });
  mobile.addEventListener('change', update);
  update();
})();
